import axios, { type InternalAxiosRequestConfig, type AxiosResponse } from "axios";
import { getSession, removeSession } from "../auth/auth.utils";
import { safeLogger } from "../utils/logger";

// ה-API רץ על /api (בהתאם ל-Route שהראית)
export const baseURL = "https://behavioranalystproject.onrender.com/api";


const axiosInstance = axios.create({
  baseURL,
  // אם אתם עובדים עם cookies/sessions בצד השרת — בטלו את ההערה:
  // withCredentials: true,
  timeout: 60000,
});

// ----- Request interceptor: מוסיף JWT אם קיים + לוג -----
axiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = getSession();
    if (token) {
      config.headers = config.headers ?? {};
      config.headers["Authorization"] = `Bearer ${token}`;
      console.log(`[DEBUG-API] Request with token: ${config.method?.toUpperCase()} ${config.url}`);
      safeLogger.log(`API Request with token: ${config.method?.toUpperCase()} ${config.url}`);
    } else {
      console.log(`[DEBUG-API] Request without token: ${config.method?.toUpperCase()} ${config.url}`);
      safeLogger.log(`API Request without token: ${config.method?.toUpperCase()} ${config.url}`);
    }
    return config;
  },
  (error) => {
    console.error("[DEBUG-API] Request error:", error);
    safeLogger.error(`API Request error: ${String(error)}`);
    return Promise.reject(error);
  }
);

// ----- Response interceptor: לוג + טיפול ב-401 במקום אחד -----
axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => {
    console.log(
      `[DEBUG-API] Response: ${response.config.method?.toUpperCase()} ${response.config.url} - Status: ${response.status}`
    );
    safeLogger.log(
      `API Response: ${response.config.method?.toUpperCase()} ${response.config.url} - Status: ${response.status}`
    );
    return response;
  },
(error) => {
  const status = error?.response?.status;
  const url = error?.config?.url;
  console.error(`[DEBUG-API] Error: ${status || "Network Error"} - ${url}`, error);
  safeLogger.error(`API Error: ${status || "Network Error"} - ${url}`);

  if (status === 401) {
    const token = getSession();

    // ✅ אין token => משתמש חדש לפני פרופיל => לא להפנות
    if (!token) return Promise.reject(error);

    removeSession();
    window.location.href = "/login";
    // return; 
  }

  return Promise.reject(error);
}
);

export default axiosInstance;